import React, { useEffect, useState } from 'react';
import { reprocessingEnabledSelector } from '../../auth/selectors/auth.selectors';
import * as ecgClient from '../clients/ecg.client';
import { Loading } from '../../../shared/components/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { loadData } from '../thunks/load-data.thunk';
import { useInterval } from '../../../shared/hooks/useInterval';

interface Props {
  ecgId: string;
}

export const Reprocessor: React.FC<Props> = ({ ecgId }) => {
  const dispatch = useDispatch();
  const [polling, setPolling] = useState(false);
  const reprocessingEnabled = useSelector(reprocessingEnabledSelector);

  useEffect(() => {
    (async () => {
      if (reprocessingEnabled) {
        await ecgClient.reprocessEcg(ecgId);
        setPolling(true);
      }
    })();
  }, [ecgId, reprocessingEnabled]);

  useInterval(() => {
    if (polling && reprocessingEnabled) {
      dispatch(loadData(ecgId));
    }
  }, 5000);

  return <Loading>Reprocessing, please wait...</Loading>;
};
